import { useGetLocationOperatoryProviderList } from '../scheduler-v3/use-get-location-operatory-provider-list';

type UseAvailabilityRuleFormDataProps = {
  locationId: string | undefined;
};

export const useAvailabilityRuleFormData = ({ locationId }: UseAvailabilityRuleFormDataProps) => {
  const { operatoryList, providerList } = useGetLocationOperatoryProviderList({
    locationIds: locationId ? [locationId] : [],
  });

  return { operatoryList, providerList };
};
